import React, { useState } from "react";
import BotCollection from "./components/BotCollection";
import YourBotArmy from "./components/YourBotArmy";
import BotSpecs from "./components/BotSpecs";

function App() {
  const [army, setArmy] = useState([]);
  const [selectedBot, setSelectedBot] = useState(null);

  const handleBotClick = (bot) => {
    console.log('Bot clicked:', bot); // Debugging statement
    setSelectedBot(bot);
  };

  const handleEnlistBot = (bot) => {
    if (!army.some((b) => b.id === bot.id)) {
      setArmy([...army, bot]);
    }
    setSelectedBot(null);
  };

  const handleRemoveBot = (bot) => {
    setArmy(army.filter((b) => b.id !== bot.id));
  };

  const handleDischargeBot = (bot) => {
    fetch(`/bots/${bot.id}`, {
      method: "DELETE",
    }).then(() => {
      setArmy(army.filter((b) => b.id !== bot.id));
    }).catch((error) => {
      console.error("Failed to discharge bot:", error);
    });
  };

  const handleBackToCollection = () => {
    setSelectedBot(null);
  };

  return (
    <div className="App">
      <YourBotArmy
        army={army}
        onRemove={handleRemoveBot}
        dischargeBot={handleDischargeBot}
      />
      {selectedBot ? (
        <BotSpecs
          bot={selectedBot}
          onEnlist={handleEnlistBot}
          onBack={handleBackToCollection}  // Correct function reference
        />
      ) : (
        <BotCollection
          onBotClick={handleBotClick}  // Ensure this function is passed
          dischargeBot={handleDischargeBot}
        />
      )}
    </div>
  );
}

export default App;
